import { Injectable, Injector } from '@angular/core';
import { SetorAlmoxarifado } from '../../../entidade/almoxarifado/setor-almoxarifado.model';
import { BaseResourceService } from '../../../models/services/base-resource.service';
import { Page } from '../../../util/page';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SetorAlmoxarifadoService extends BaseResourceService<SetorAlmoxarifado> {

  constructor(
    protected injector: Injector
  ) {
    super(`setores-almoxarifados`, injector);
  }


  public setorUsuarios(usuarioId: number, orgaoId: number, estoqueId: number, nomeSetor?: string, codigoSetor?: string, cidadeId?: number): Observable<Page> {

    if (this.login?.cidade?.id) {
      cidadeId = this.login.cidade.id;
    } else if (!cidadeId) {
      cidadeId = 1;
    }
    return this.http.post
      (`${cidadeId}/${this.api}/setor-usuarios`, { usuarioId, orgaoId, estoqueId, nomeSetor, codigoSetor }, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
